"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableAdditionalProperty = exports.resultsTableAdditionalPropertyDefinition = void 0;
exports.resultsTableAdditionalPropertyDefinition = {
    view: { label: 'Results Table Additional' },
    constraints: [
        {
            name: 'properties',
            argument: ['results-table'],
        },
    ],
    type: 'container',
    multiple: true,
    name: 'results-table-additional',
};
const isResultsTableAdditionalProperty = (prop) => {
    return prop.name === exports.resultsTableAdditionalPropertyDefinition.name;
};
exports.isResultsTableAdditionalProperty = isResultsTableAdditionalProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1hZGRpdGlvbmFsLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcmVzdWx0cy10YWJsZS1hZGRpdGlvbmFsLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsd0NBQXdDLEdBQUc7SUFDdEQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLDBCQUEwQixFQUFFO0lBQzNDLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFlBQVk7WUFDbEIsUUFBUSxFQUFFLENBQUMsZUFBZSxDQUFDO1NBQzVCO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsV0FBVztJQUNqQixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSwwQkFBMEI7Q0FDRCxDQUFBO0FBSTFCLE1BQU0sZ0NBQWdDLEdBQUcsQ0FBQyxJQUFrQixFQUEwQyxFQUFFO0lBQzdHLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxnREFBd0MsQ0FBQyxJQUFJLENBQUE7QUFDcEUsQ0FBQyxDQUFBO0FBRlksUUFBQSxnQ0FBZ0Msb0NBRTVDIn0=